import React from 'react'
import styles from './index.module.css'
import Typography from '../Typography'
import type { UtilityClassNames } from '@s4l/utility-css'
import { cn } from '@s4l/utility-css'

interface LoaderProps {
  readonly text: string
  readonly className?: UtilityClassNames
  readonly position?: {
    readonly top?: string
    readonly bottom?: string
    readonly left?: string
    readonly right?: string
    readonly transform?: string
  }
}

export default function Loader({ text, className, position }: LoaderProps) {
  return (
    <div
      className={cn(styles.loader, className, {
        [styles.hasPosition]: !!position,
      })}
      style={position}
    >
      <div className={styles.spinner} />
      <Typography variant="body" size="l" bold className={['display-none', 'tablet:display-block']}>
        {text}
      </Typography>
    </div>
  )
}
